const faq = ({ list }) => {
  const handleClick = ({ element }) => {
    if (element.classList.contains('active')) {
      element.classList.remove('active');
    } else {
      element.classList.add('active');
    }
  };

  const init = ({ list }) => {
    list.forEach(element => {
      const [title] = element.getElementsByClassName('Faq-title');

      if (!element.hasAttribute('data-clicked')) {
        element.setAttribute('data-clicked', 'true');
        title.addEventListener('click', () => handleClick({ element }));
      }
    });
  };

  return init({ list });
};

faq({ list: document.querySelectorAll('.Faq-item') });
